
import React from 'react'
import TaskCard from './TaskCard'
import { useTasks } from '@/hooks/useTasks'

const ArchivedTasksView: React.FC = () => {
  const { getArchivedTasks, loading } = useTasks()
  
  const { userTasks: archivedUserTasks, customTasks: archivedCustomTasks } = getArchivedTasks()

  if (loading) {
    return <div className="text-center py-8">Loading tasks...</div>
  }

  return (
    <div className="max-w-4xl">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Archived Tasks</h2>
      <div className="space-y-3">
        {archivedUserTasks.map(userTask => (
          <TaskCard 
            key={userTask.id} 
            task={{
              id: userTask.id,
              title: userTask.school_tasks.title,
              module: userTask.school_tasks.module || undefined,
              description: userTask.school_tasks.description || undefined,
              completed: true
            }}
          />
        ))}
        {archivedCustomTasks.map(customTask => (
          <TaskCard 
            key={customTask.id} 
            task={{
              ...customTask,
              completed: true
            }}
          />
        ))}
        {archivedUserTasks.length === 0 && archivedCustomTasks.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            No archived tasks yet
          </div>
        )}
      </div>
    </div>
  )
}

export default ArchivedTasksView
